export default [
  {
    path: 'facturacion',
    name: 'facturacion',
    component: () => import('./views/BillingView.vue'),
    meta: { 
      requiresAuth: true,
      title: 'facturacion',
      menuResource: 'FACTURACION' 
    },
  },
]